<template>
  <v-row class="medicine-dashboard" align="stretch">
    <v-col
      v-for="(item, index) in assetMedicineRefrigerator"
      :key="item.assetId || index"
      cols="12"
      sm="6"
      lg="4"
    >
      <div class="card-wrapper">
        <MEDICINE_REFRIGERATOR_CARD :asset="item" />
      </div>
    </v-col>
    <v-col v-if="assetMedicineRefrigerator.length === 0" cols="12">
      <v-card outlined>
        <v-card-text class="text-center py-12">
          <v-icon size="64" color="grey lighten-1">mdi-fridge-industrial-outline</v-icon>
          <div class="text-h6 grey--text mt-4">ไม่พบตู้แช่ยาในระบบ</div>
          <div class="text-body-2 grey--text">กรุณาเพิ่ม Asset ประเภทตู้แช่ยาและผูกกับ Service นี้ในฐานข้อมูล</div>
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>

<style scoped>
.medicine-dashboard {
  margin-bottom: 0;
}

.card-wrapper {
  height: 100%;
  min-height: 420px;
  padding: 4px;
}

.card-wrapper >>> .v-card {
  height: 100%;
}
</style>

<script>
import { mapState } from 'vuex'
import MEDICINE_REFRIGERATOR_CARD from '@/components/medicine_refrigerator/medicine_refrigerator_card.vue'

export default {
  name: 'MedicineRefrigeratorDashboard',
  components: {
    MEDICINE_REFRIGERATOR_CARD
  },
  computed: {
    ...mapState('Asset', ['assetMedicineRefrigerator'])
  }
}
</script>
